import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "rd-copybox",
    title: _ctx.title,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _createElementVNode("div", {
      ref: "content",
      class: _normalizeClass(["rd-copybox__content", { 'rd-copybox__content--active': _ctx.active }])
    }, _toDisplayString(_ctx.content), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["rd-copybox__spacer", { 'rd-copybox__content--active': _ctx.active }])
    }, null, 2),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "rd-copybox__icon" }, [
      _createElementVNode("i", { class: "fas fa-clipboard" })
    ], -1)),
    (_ctx.active)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["rd-copybox__success", { 'rd-copybox__success--active': _ctx.active }])
        }, "Copied to clipboard!", 2))
      : _createCommentVNode("", true),
    (_ctx.hasFailed)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["rd-copybox__success error", { 'rd-copybox__success--active': _ctx.hasFailed }])
        }, "Copy failed!", 2))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}